<button
  mat-flat-button
  type="button"
  class="export-button flex align-center justify-center radius-2 brd brd-200 bg-white text-900 weight-medium cursor-pointer"
  [class.cursor-not-allowed]="disabled"
  [disabled]="disabled"
  (click)="onExportButtonClicked()"
>
  <app-icon name="bold-download-minimalistic" size="sm" class="text-900 mr-1"></app-icon>
  <span class="export-button__label">{{ "Buttons.Export" | translate }}</span>
</button>
